import axios from 'axios'
import store from '@/store';
import router from '@/router';
//import { now } from '@/utilities/date-format';

const http = axios.create({
    baseURL: process.env.VUE_APP_API_URI
})

http.interceptors.request.use(
    async (config) => {
        //if (store.state.auth.access_token_expired < now()) {
        //    //トークンのリフレッシュ
        //    await axios.post(process.env.VUE_APP_API_URI + '/signin/refresh', {
        //        refresh_token: store.state.auth.refresh_token
        //    }).then((response) => {
        //        store.commit('auth/setAccessToken', response.data);
        //    }).catch(() => {
        //        //敢えて捕捉せず、メインリクエストで401にさせる
        //    });
        //}

        config.headers = {
            Authorization: 'Bearer ' + store.state.auth.access_token,
            'X-Requested-With': "XMLHttpRequest",
        }
        return config;
    }
)

// Request IDを取得するヘルパー関数
const getRequestId = (error) => {
    return error.response?.headers?.['x-request-id'] || 'unknown';
}

// エラーメッセージを送信するヘルパー関数
const showErrorMessage = (title, message, icon, error) => {
    let message_detail = {
        title,
        message,
        icon,
        request_id: getRequestId(error)
    }
    let event = new CustomEvent('show_error_message', {detail: message_detail});
    window.dispatchEvent(event);
}

http.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response && error.response.status === 400) {
            showErrorMessage('エラー', error.response.data.message, 'error', error);

        } else if (error.response && error.response.status === 401) {
            let message_detail = {
                title: 'ログイン切れ',
                message: 'ログインの有効期間が切れました。ログイン画面に移動します',
                icon: 'error'
            }
            let event = new CustomEvent('show_error_message', {detail: message_detail});
            window.dispatchEvent(event);

            store.commit('auth/signOut'); //ログイン情報削除
            store.commit('condition/signOut') //検索条件削除
            router.push('/signin');

        } else if (error.response && error.response.status === 402) {
            showErrorMessage('利用期限切れ', '利用期限が切れました。クレジットカードの登録または変更が必要です。', 'error', error);
            router.push('/system/payment');

        } else if (error.response && error.response.status === 403) {
            showErrorMessage('権限エラー', 'この操作をする権限がありません。必要な場合、管理者に権限の変更を依頼してください。', 'error', error);

        } else if (error.response && error.response.status === 404) {
            showErrorMessage('404エラー', 'データが見つかりません', 'error', error);

        } else if (error.response && error.response.status === 418) {
            showErrorMessage('有効期限切れ', 'ページを再読み込みしてください。', 'error', error);

        } else if (error.response && error.response.status === 422) {
            let errors = error.response.data.errors;
            let errorMessages = [];
            Object.keys(errors).forEach((key) => {
                let array_order = key.match(new RegExp(/\.([0-9]+)\./));
                if (array_order) {
                    //ネストしている場合は何行目が間違っているか表示する（多重ネストは非対応です）
                    let row_number = parseInt(array_order[1]) + 1;
                    errorMessages.push(`${row_number}行目の${errors[key]}`);
                } else {
                    errorMessages.push(errors[key]);
                }
            });

            showErrorMessage('入力内容に誤りがあります', errorMessages.join("\n"), 'error', error);

        } else {
            showErrorMessage('エラー', 'システムエラーが発生しました', 'error', error);
        }

        return Promise.reject(error);
    }
)

export default http
